/* global axios */
import ApiClient from '../ApiClient';

class YandexClient extends ApiClient {
  constructor() {
    super('yandex', { accountScoped: true });
  }

  generateAuthorization(payload) {
    return axios.post(`${this.url}/authorization`, payload);
  }

  // Creates the link an admin hands to whoever owns the mailbox, and reports
  // how far along they are with it.
  createInvite() {
    return axios.post(`${this.url}/invites`);
  }

  getInvite(token) {
    return axios.get(`${this.url}/invites/${token}`);
  }
}

export default new YandexClient();
